import assign from 'lodash/assign';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

import PropertyOverview from 'app/shared/model/PropertyOverview';

const initState = () => PropertyOverview();

const currentProperty = (state = initState(), action = {}) => {
    const { type, payload } = action;

    if (type === DispatchConstants.UPDATE_PROPERTY_OVERVIEW) {
        return assign({}, state, payload);
    }

    return state;
};

export default currentProperty;
